import {Locale} from "next-intl";
import {SettingsNavigationProperty} from "@pata/settings";
import {getLocale, getTranslations} from "next-intl/server";

export default async function fetchSubMenu(): Promise<SettingsNavigationProperty[]> {
    const locale: Locale = await getLocale()
    const t = await getTranslations('Navigation')
    
    switch (locale) {
        default:
            return [
                { name: t('sustainability'), path: "/sustainability", htmlId: 1419 },
                { name: t('about-us'), path: "/about-us", htmlId: 1410 },
                { name: t('contact-us'), path: "/contact-us", htmlId: 1409 },
                { name: t('mana-pata'), path: "https://mana.pata.lv/", htmlId: 2301 },
            ]
        case "en":
            return [
                { name: t('sustainability'), path: "/sustainability", htmlId: 1075 },
                { name: t('about-us'), path: "/about-us", htmlId: 620 },
                { name: t('contact-us'), path: "/contact-us", htmlId: 625 },
            ]
        case "lt":
            return [
                { name: t('sustainability'), path: "/sustainability", htmlId: 1665 },
                { name: t('about-us'), path: "/about-us", htmlId: 1663 },
                { name: t('contact-us'), path: "/contact-us", htmlId: 1664 },
            ]
        case "cn":
            return [
                { name: t('about-us'), path: "/about-us", htmlId: 1407 },
                { name: t('contact-us'), path: "/contact-us", htmlId: 1406 },
            ]
    }
}